import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { helpers } from '@kurtosys/types/index.js';
import { IQueryOptions } from '@kurtosys/types/query/index.js';

export function getQueryClass(dependencies: IQueryClassDependency & ITransformClassDependency, query: IQueryOptions, translationHelper?: helpers.ITranslationHelper, callStackLevel?: number) {
	if (dependencies && dependencies.queryClass) {
		return new dependencies.queryClass(query, translationHelper, callStackLevel);
	}
}